import { KeycloakService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import styles from './UserLoginSSO.module.scss'

export function UserLoginSSO() {
  const signIn = () => {
    KeycloakService.doLogin()
  }

  return (
    <div className={styles['container']}>
      <div className={styles['sign-in']}>
        <div className={styles['text']}>Sign in to the Nomination Module</div>
        <NVButton classes={{ container: styles['button'] }} type='submit' text={'Continue'} onClick={() => signIn()} />
      </div>
    </div>
  )
}
